module.exports = __webpack_public_path__ + "static/media/stop-9.1578326e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/stop-markers/alt-color/stop-9.svg
// module id = 1376
// module chunks = 0